import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Button, Col, Row, Alert } from "reactstrap";
import { Accordion, Form } from "react-bootstrap";
import { RiCheckboxCircleFill, RiInformationLine } from "react-icons/ri";
import { useContext } from "react";
import KYBCompanyContext from "../../../../contexts/KYBCompanyContext";
import { KYBAvailableServices } from "src/modules/3rd-party-management/constants";

const SelectDataSource = ({
    t,
    onNextButtonClicked,
    onBackButtonClicked,
    onCancelButtonClicked
}) => {
    const {
        companyData, 
        setCompanyData
    } = useContext(KYBCompanyContext);

    const toggleService = (id) => {
        setCompanyData((currentState) => {
            const isSelected = currentState.services.includes(id);
            let updatedServices;

            if (isSelected) {
                updatedServices = currentState.services.filter((service) => service !== id);
            } else {
                updatedServices = [...currentState.services, id];
            }

            return { ...currentState, services: updatedServices };
        });
    };

    const selectedServicesCount = companyData.services?.length;

    return (
        <Row>
            <Col sm="12">
                <Alert color="info" className="d-flex align-items-center justify-content-start gap-2">
                    <RiInformationLine size={40} />
                    <div>
                        <strong>{t('Choose Data Providers')}</strong>
                        <p className="mb-0">
                            {t('Select one or more data providers to retrieve company information. Expand each provider to review the available reports and data types before making your selection. Data availability and coverage may vary by jurisdiction.')}
                        </p>
                    </div>
                </Alert>
            </Col>
            <Col sm='12' className="mb-3 custom-accordion">
                <Accordion alwaysOpen defaultActiveKey={['0', '1']}>
                    {KYBAvailableServices.filter((service) => service.enableFetchReport).map((service, i) => {
                        const isSelected = companyData.services.includes(service.id);

                        return (
                            <Accordion.Item eventKey={i.toString()}>
                                <Accordion.Header>
                                    <div className="d-flex align-items-center w-100 justify-content-between">
                                        <div className="d-flex align-items-center gap-2">
                                            <Form.Check
                                                type="switch"
                                                id={`service-${service.id}`}
                                                checked={isSelected}
                                                onChange={() => toggleService(service.id)}
                                                onClick={(e) => e.stopPropagation()}
                                                aria-label={`Select ${service.title}`}
                                            />
                                            <span className={isSelected ? "fw-semibold" : "fw-normal"}>
                                                {service.title} - {t('Available Reports & Data')}
                                            </span>
                                        </div>

                                        {isSelected && (
                                            <span className="badge bg-success me-2">
                                                {t('Selected')}
                                            </span>
                                        )}
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>{service.description}</p>
                                    <Row>
                                        {service.reportTitles.map((title, j) => (
                                            <Col sm='6' key={j} className="mb-2">
                                                <RiCheckboxCircleFill
                                                    className="text-success me-2"
                                                    size="20"
                                                />
                                                {t(title)}
                                            </Col>
                                        ))}
                                    </Row>
                                </Accordion.Body>
                            </Accordion.Item>
                        )
                    })}
                </Accordion>
            </Col>

            <Col sm='12' className="d-flex justify-content-between">
                <Button
                    color="secondary"
                    outline
                    type="button"
                    onClick={onCancelButtonClicked}
                >
                    {t('Cancel')}
                </Button>

                <div>
                    <Button
                        color="secondary"
                        onClick={onBackButtonClicked}
                        className="me-2"
                        type="button"
                    >
                        {t('Back')}
                    </Button>

                    <Button
                        color="primary"
                        type="button"
                        onClick={onNextButtonClicked}
                        disabled={!selectedServicesCount}
                    >
                        {t('Next')}
                    </Button>
                </div>
            </Col>
        </Row>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        user: state.Login.user,
        token: token
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps,
        {}
    )(SelectDataSource)
)